// src/components/apiFetch.js
// Utility to wrap fetch and redirect to /app on 401

export async function apiFetch(url, options = {}) {
  const response = await fetch(url, options);
  if (response.status === 401) {
    window.location.href = '/signin';
    // Optionally, return a rejected promise so calling code can handle it
    throw new Error('Unauthorized (401)');
  }
  return response;
}
